'use strict';

const errorNotificationDialog = require('../components/errorNotificationDialog');

/**
 * change favorite button
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked to add a product to the wishlist
 */
function changeFavoriteButton(data, button) {
    $.spinner().stop();
    button.removeAttr('disabled');
    var url = button.data('action-url');
    var status;
    if (data.success) {
        var wasFavorite = JSON.parse(button.attr('data-is-favorite').toLowerCase());
        if (wasFavorite) {
            // 登録機能に変更
            url = url.replace('Wishlist-RemoveProduct', 'Wishlist-AddProduct');
            button.attr('data-action-url', url);
            button.attr('data-action', 'Wishlist-AddProduct');
        } else {
            // 登録解除機能に変更
            url = url.replace('Wishlist-AddProduct', 'Wishlist-RemoveProduct');
            button.attr('data-action-url', url);
            button.attr('data-action', 'Wishlist-RemoveProduct');
        }
        button.attr('data-is-favorite', !wasFavorite);
        button.toggleClass('is-active');
    } else {
        // エラーメッセージの表示
    }
}

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
 function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
        return key + '=' + encodeURIComponent(params[key]);
    }).join('&');

    return newUrl;
}

module.exports = function () {
    $('.button-favorite').on('click', function (e) {
        e.preventDefault();
        var button = $(this);
        var productID = $(this).attr('data-pid');
        var uuid = $(this).attr('data-uuid');
        var url = $(this).attr('data-action-url');
        var action = $(this).attr('data-action');
        var optionId = $(this).closest('.product-detail').find('.product-option').attr('data-option-id');
        var optionVal = $(this).closest('.product-detail').find('.options-select option:selected').attr('data-value-id');
        optionId = optionId || null;
        optionVal = optionVal || null;
        var data = {
            pid: productID,
            uuid: uuid,
            optionId: optionId,
            optionVal: optionVal
        };

        if (!url || !productID) {
            return;
        }

        if (action == "Wishlist-AddProduct") {
            $.spinner().start();
            button.attr('disabled', true);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: data,
                success: function (data) {
                    changeFavoriteButton(data, button);
                    $.spinner().stop();
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        errorNotificationDialog(err.responseJSON.errorMessage);
                        $.spinner().stop();
                    }
                }
            });
        } else if (action == "Wishlist-RemoveProduct") {
            url = appendToUrl(url, data);

            $.spinner().start();
            button.attr('disabled', true);
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                success: function (data) {
                    changeFavoriteButton(data, button);
                    $.spinner().stop();
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        errorNotificationDialog(err.responseJSON.errorMessage);
                        $.spinner().stop();
                    }
                }
            });
        }
    });
};
